import $ from "jquery";

const ICONS = {
  success: '<svg class="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>',
  danger: '<svg class="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>'
};

const removeAllMessages = () => {
  $("#container-body > .alert").remove();
};

const fadeOut = () => {
  setTimeout(function(){
    $(".alert" ).fadeOut();
  }, 5000);
};

const createAlertTemplate = (type, text, color) => {
  return `
    <div class="alert style-flash alert-${type} max-w-sm w-full bg-${color}-50 border border-${color}-100 shadow-lg rounded-lg pointer-events-auto">
      <div class="flex items-start">
        <div class="flex-shrink-0 text-${color}-400">
          ${ICONS[type]}
        </div>
        <div class="ml-3 w-0 flex-1">
          <div class="text-sm font-medium text-${color}-800">
            ${type === 'success' ? 'Success' : 'Error'}
          </div>
          <div class="mt-1 text-sm text-${color}-600">
            ${text}
          </div>
        </div>
        <div class="ml-4 flex-shrink-0 flex">
          <button class="rounded-md inline-flex text-${color}-400 close hover:text-${color}-500 focus:outline-none focus:ring-2 focus:ring-${color}-500 focus:ring-offset-2" aria-label="Close" data-dismiss="alert" type="button">
          </button>
        </div>
      </div>
    </div>
  `;
};

const showFlashMessage = (type, text, color) => {
  removeAllMessages();
  const $container = $("#container-body");
  if (!$container.length) {
    return;
  }
  const $alert = $(createAlertTemplate(type, text, color));
  $container.prepend($alert);
};

window.showMessage = (text, opts = {}) => {
  showFlashMessage('success', text, 'green');
  if (!opts.noFade) fadeOut();
};

window.showError = (text) => {
  showFlashMessage('danger', text, 'red');
  fadeOut();
};

$(function() {
  setTimeout(function(){
    $(".alert" ).fadeOut();
  }, 5000);
});
